<template>
  <v-row justify="center" class="mt-5 mb-8" no-gutters>
    <v-col cols="12" class="py-0 d-flex justify-center">
      <span class="text-center">
        {{ $t('message.disableAdBlockMessage') }}<br />
        <a :href="articleLink" target="_blank"
          >{{ $t('message.knowMore') }} &raquo;</a
        >
      </span>
    </v-col>
    <v-col cols="12" class="py-0 d-flex justify-center">
      <v-btn
        class="mt-3"
        color="primary"
        @click="fetchData"
        :loading="isLoading"
        :disabled="isLoading"
        >{{ $t('message.pages.video.metricsPage.tryAgain') }}</v-btn
      >
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'AdBlockErrorMessage',
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    fetchData() {
      this.$emit('handleFetchData')
    },
  },
  computed: {
    articleLink() {
      if (this.locale === 'en') {
        return 'https://help.pandavideo.com/en-us/article/why-should-i-disable-adblock-srvp9x/'
      }
      return 'https://help.pandavideo.com/pt-br/article/por-que-devo-desabilitar-o-adblock-7nouzx/'
    },
    locale() {
      return this.$i18next.resolvedLanguage
    },
  },
}
</script>
